var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "benefits-section" },
    [
      _c(
        "el-row",
        {
          staticClass: "benefits-section-inner",
          attrs: { type: "flex", align: "middle" }
        },
        [
          _c("el-col", { attrs: { xs: 24, sm: 12 } }, [
            _c("h2", { staticClass: "section-title" }, [
              _vm._v("Why Join U-Connect?")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "benefit-item" }, [
              _c("h3", { staticClass: "benefit-item-title" }, [
                _vm._v("Extended Market Reach:")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "benefit-item-description" }, [
                _vm._v(
                  "U-Connect connects you with interstate and international buyers, expanding your client base to new markets and helping you reach those eager for off-the-plan and new-build properties."
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "benefit-item" }, [
              _c("h3", { staticClass: "benefit-item-title" }, [
                _vm._v("Exclusive Off-Market Opportunities:")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "benefit-item-description" }, [
                _vm._v(
                  "Benefit from an exclusive stock list, including off-market properties that provide clients with unique investment options not found on general listings."
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "benefit-item" }, [
              _c("h3", { staticClass: "benefit-item-title" }, [
                _vm._v("Additional Revenue Streams:")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "benefit-item-description" }, [
                _vm._v(
                  "Gain access to commission-sharing opportunities on closed deals, providing an additional income source by supporting clients in their property journey."
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            {
              staticClass: "image-container-wrapper",
              attrs: { xs: 24, sm: 12 }
            },
            [
              _c("div", { staticClass: "image-container" }, [
                _c("img", {
                  staticClass: "feature-image",
                  attrs: {
                    src: require("../../../assets/u-connect-reg-section-3-backgroud.png"),
                    alt: "Blueprint review process"
                  }
                })
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-113957a1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-113957a1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/uConnectRegistrationSection3.vue
// module id = null
// module chunks = 